import CountUp from "./countUp";

const HeroStat = ({ label, value, color = "blue", icon }) => {
  const colors = {
    blue: {
      gradient: "from-[#081A3A] to-blue-600",
      glow: "shadow-cyan-500/30",
      border: "border-cyan-400/20",
    },
   
  };

  const theme = colors[color];

  return (
    <div
      className={`
        relative overflow-hidden
        rounded-3xl p-6
        flex flex-col items-center justify-center
        text-white
        bg-gradient-to-br ${theme.gradient}
        backdrop-blur-xl
        border ${theme.border}
        shadow-2xl ${theme.glow}
        transition-all duration-500
        hover:scale-105 hover:shadow-3xl
        group
      `}
    >
      {/* Floating Glow Effect */}
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-white/10 rounded-full blur-3xl group-hover:scale-125 transition-all duration-700"></div>

      {/* Icon */}
      {icon && (
        <div className="mb-3 p-3 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 group-hover:rotate-6 transition-all duration-500">
          {icon}
        </div>
      )}

      {/* Label */}
      <p className="text-xs uppercase tracking-widest opacity-80 mb-1">
        {label}
      </p>

      {/* Value */}
      <h2 className="text-4xl md:text-5xl font-black tracking-tight">
                       <CountUp value={value} duration={1200} />

      </h2>
    </div>
  );
};

export default HeroStat;